module.exports = __webpack_public_path__ + "media/icons/bookmark-filled-30ce8ad2.svg";